import services from '@/services/ascentiaServiceIndex'
import { ROLE_MANAGEMENT_CONSTS as RM } from '../consts'
import {
  calculatePermissionLevelByPermissions,
  calculatePermissionsByLevel,
} from '../../utilities/userPermissions'

const state = {
  allRoleDataLoading: false,
  rolesData: [],
  allResources: [],
  allResourceModules: [],
  singleRole: {
    resources: [],
  },
}

const getters = {}

const mutations = {
  [RM.ALL_ROLES_LOADING]: (state, data) => (state.allRoleDataLoading = data),
  [RM.UPDATE_ALL_ROLES]: (state, data) => (state.rolesData = data),
  [RM.UPDATE_ALL_RESOURCES]: (state, data) => (state.allResources = data),
  [RM.UPDATE_ALL_RESOURCE_MODULES]: (state, data) =>
    (state.allResourceModules = data),
  [RM.UPDATE_SINGLE_ROLE]: (state, data) => (state.singleRole = data),
}

const actions = {
  async [RM.GET_ALL_ROLES]({ commit }, args = { refresh: true }) {
    try {
      commit(RM.ALL_ROLES_LOADING, true)
      const response = await services.roleManagement.getData(
        'allRoles',
        null,
        args.refresh,
      )
      const data = response.data
      commit(RM.UPDATE_ALL_ROLES, data)
      commit(RM.ALL_ROLES_LOADING, false)
    } catch (error) {
      console.log(`${[RM.UPDATE_ALL_ROLES]}: error ${error}`)
    }
  },
  async [RM.GET_ALL_RESOURCES]({ commit }) {
    try {
      const resourcesResponse = await services.roleManagement.getData(
        'allResources',
      )
      const resources = resourcesResponse.data
      const resourceModulesResponse = await services.roleManagement.getData(
        'allResourceModules',
      )
      const resourceModules = resourceModulesResponse.data
      commit(RM.UPDATE_ALL_RESOURCES, resources)
      commit(RM.UPDATE_ALL_RESOURCE_MODULES, resourceModules)
    } catch (error) {
      console.log(`${[RM.GET_ALL_RESOURCES]}: error ${error}`)
    }
  },
  async [RM.GET_SINGLE_ROLE]({ commit }, roleId) {
    try {
      const response = await services.roleManagement.getData(
        'role',
        roleId,
        true,
      )
      const data = response.data
      let resources = []

      for (const resource of data.resources) {
        const existing = true

        const permissions = calculatePermissionsByLevel(
          resource.permissionLevel,
        )

        const newResource = {
          ...resource,
          ...permissions,
          existing,
        }

        resources.push(newResource)
      }

      data.resources = resources

      commit(RM.UPDATE_SINGLE_ROLE, data)
    } catch (error) {
      console.log(`${[RM.GET_SINGLE_ROLE]}: error ${error}`)
    }
  },
  async [RM.SAVE_ROLE_DETAILS]({ commit, dispatch }, roleData) {
    try {
      commit(RM.ALL_ROLES_LOADING, true)

      let resources = []

      for (const resource of roleData.resources) {
        const permissionLevel = calculatePermissionLevelByPermissions(resource)

        const newResource = {
          ...resource,
          permissionLevel: permissionLevel,
        }

        if (permissionLevel > 0) {
          resources.push(newResource)
        }
      }

      roleData.resources = resources

      const response = await services.roleManagement.saveData(
        'addRole',
        roleData,
        true,
      )
      if (response.status === 201 && response.data !== null) {
        dispatch(RM.GET_ALL_ROLES, { refresh: true })
      }
      commit(RM.ALL_ROLES_LOADING, false)
    } catch (error) {
      console.log(`${[RM.SAVE_ROLE_DETAILS]}: error ${error}`)
    }
  },
  async [RM.UPDATE_ROLE_DETAILS]({ commit, dispatch }, roleData) {
    try {
      commit(RM.ALL_ROLES_LOADING, true)

      let resources = []

      for (const resource of roleData.resources) {
        const permissionLevel = calculatePermissionLevelByPermissions(resource)

        const newResource = {
          ...resource,
          permissionLevel: permissionLevel,
        }

        if (permissionLevel > 0) {
          resources.push(newResource)
        }
      }

      roleData.resources = resources

      const response = await services.roleManagement.saveData(
        'updateRole',
        roleData,
        true,
      )
      if (response.status === 200 && response.data !== null) {
        dispatch(RM.GET_ALL_ROLES, { refresh: true })
      }
      commit(RM.ALL_ROLES_LOADING, false)
    } catch (error) {
      console.log(`${[RM.UPDATE_ROLE_DETAILS]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
